import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CSSBuySpreadsheetGuide from "@/pages/article/cssbuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <CSSBuySpreadsheetGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;